module.exports = __webpack_public_path__ + "img/xiaomi-7.fedd11da.png";